import { breakpoints } from "./breakpoints";

(function ($) {

  $(function () {
    const $subitems = $(".o-megaMenu__item");
    const $subSeconditems = $(".js-megaSub");
    const $dim = $(".js-dim");
    const $navContainer = $(".js-navContainer");
    const $navigationToggle = $(".js-toggleNavigation");
    const $navigationHamburger = $(".js-hamburger");
    const $header = $(".js-header");
    const $body = $("body");

    let isDesktop = window.innerWidth >= breakpoints.viewport_lg;

    setupNavigation(isDesktop);

    let resizeTimeout;
    $(window).on("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const nowDesktop = window.innerWidth >= breakpoints.viewport_lg;
        if (nowDesktop !== isDesktop) {
          isDesktop = nowDesktop;
          teardownNavigation();
          setupNavigation(isDesktop);
        }
      }, 150);
    });

    const handleScroll = () => {
      // Get the current scroll position
      let scrollOffset = $(window).scrollTop();

      // Check if the scroll offset is greater than 1px
      if (scrollOffset > 1) {
        // Add the '-scroll' class to the '.js-header' element
        $header.addClass('-scroll');
      } else {
        // Remove the '-scroll' class from the '.js-header' element
        $header.removeClass('-scroll');
      }
    }

    $(window).on("scroll", function () {
      handleScroll();
    });

    handleScroll(); // Run on initial load

    function setupNavigation(desktop) {
      if (desktop) {
        setupDesktopNavigation();
      } else {
        setupMobileNavigation();
      }
    }

    function teardownNavigation() {
      // Remove all event listeners before switching modes
      $subitems.off();
      $subSeconditems.off();
      $header.off();
      $navigationToggle.off();
      $(window).off("resize.megaMenu");
    }

    function setupDesktopNavigation() {
      // Hover handling
      $subitems.on("mouseenter", function () {
        const $item = $(this);
        $subitems.removeClass("-active");
        $item.addClass("-active");

        $dim.toggleClass("-active", $item.hasClass("-mega"));
        if (!$item.hasClass("-sub")) {
          $subitems.removeClass("-active");
        }
      });

      $header.on("mouseleave", function () {
        $subitems.removeClass("-active");
        $dim.removeClass("-active");
      });
    }

    function setupMobileNavigation() {
      // Toggle hamburger
      $navigationToggle.on("click", function () {
        toggleMainNavigation();
      });

      // First-level submenu
      $subitems.find(".js-subMenuArrow").on("click", function () {
        const $item = $(this);
        $subitems.removeClass("-active");
        $item.parent().addClass("-active");
        $navContainer.css("transform", "translate(-100%, 0)");
      });

      // Second-level submenu
      $subSeconditems.find(".js-subMenuSecondArrow").on("click", function () {
        const $item = $(this);
        $subSeconditems.removeClass("-active");
        $item.parent().addClass("-active");
        $navContainer.css("transform", "translate(-200%, 0)");
      });

      // Return button
      $subitems.find(".js-returnStart").on("click", function () {
        $navContainer.css("transform", "translate(0, 0)");
      });
    }

    function toggleMainNavigation() {
      $header.toggleClass("-navOpen");
      $navigationToggle.toggleClass("-active");
      $navigationHamburger.toggleClass("-active");
      $header.removeClass('-scroll');
      $body.toggleClass("-overflow");
      $navContainer.css("transform", "");

      if ($header.hasClass("-navOpen")) {
        $subitems.removeClass("-active");
        $subSeconditems.removeClass("-active");
      }
    }

  });

})(jQuery);